import {
  ChangeDetectionStrategy,
  Component,
  inject,
  ViewChild,
} from '@angular/core';
import { Table, TableModule } from 'primeng/table';
import { Paginator } from 'primeng/paginator';
import { InputText } from 'primeng/inputtext';
import { Button } from 'primeng/button';
import { DatePipe } from '@angular/common';
import { Card } from 'primeng/card';
import { FormsModule } from '@angular/forms';
import { DatePicker } from 'primeng/datepicker';
import { Select } from 'primeng/select';
import { TableBaseAbstractComponent } from '../../../../../shared/components/table-base-abstract.component';
import { AnnouncementHistoryEntry } from '../../../../../shared/models/announcement-history-entry';
import { AnnouncementsApi } from '../../../../../shared/services/api/announcements.api';
import { TableRequestData } from '../../../../../shared/models/table/table-request-param';
import { TableResponse } from '../../../../../shared/models/table-response';
import { Observable } from 'rxjs';
import { DialogService } from 'primeng/dynamicdialog';
import { AnnouncementHistoryEntryDetailsDialog } from '../announcement-history-entry-details-dialog/announcement-history-entry-details-dialog';
import { ActivatedRoute } from '@angular/router';
import { Tooltip } from 'primeng/tooltip';
import { AnnouncementEventType } from '../../../../../shared/enums/announcement-event-type.enum';

@Component({
  selector: 'app-admin-panel-announcement-history',
  imports: [
    Button,
    Card,
    DatePipe,
    FormsModule,
    InputText,
    DatePicker,
    Paginator,
    Select,
    TableModule,
    Tooltip,
  ],
  templateUrl: './announcement-history.component.html',
  styleUrl: './announcement-history.component.scss',
  providers: [AnnouncementsApi],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AnnouncementHistoryComponent extends TableBaseAbstractComponent<AnnouncementHistoryEntry> {
  @ViewChild('table') override tableRef!: Table;

  readonly #announcementsApi = inject(AnnouncementsApi);
  readonly #route = inject(ActivatedRoute);
  readonly #announcementId: number;
  readonly #dialogService = inject(DialogService);

  protected tableFilters = {
    dataZdarzenia: '',
    obiekt: null as string | null,
    rodzajZdarzenia: null as string | null,
    autorNazwa: '',
  };

  protected readonly ANNOUNCEMENT_EVENT_TYPE = AnnouncementEventType;
  protected readonly eventTypeOptions = Object.entries(AnnouncementEventType)
    .map(([key, label]) => ({
      label,
      value: key,
    }));

  protected readonly eventObjectOptions = [
    {
      label: 'KOMUNIKAT',
      value: 'KOMUNIKAT',
    },
  ];

  constructor() {
    super();

    this.#announcementId = Number(this.#route.snapshot.paramMap.get('id'));
  }

  protected override apiCall$ = (
    params: TableRequestData,
  ): Observable<TableResponse<AnnouncementHistoryEntry>> => {
    return this.#announcementsApi.getAnnouncementHistoryTable$(
      this.#announcementId,
      params,
    );
  };

  protected onFilterChangeMobile(
    target: EventTarget | null,
    field: string,
  ): void {
    this.onPrimeFilterChangeMobile(target as any, field);
  }

  protected showDetails(entry: AnnouncementHistoryEntry): void {
    this.#dialogService.open(AnnouncementHistoryEntryDetailsDialog, {
      header: 'Podgląd zdarzenia komunikatu',
      closable: true,
      modal: true,
      closeOnEscape: true,
      dismissableMask: true,
      width: '900px',
      breakpoints: {
        '960px': '90vw',
        '640px': '90vw',
      },
      inputValues: { event: entry },
    });
  }

  protected clearFilters(): void {
    this.tableFilters = {
      dataZdarzenia: '',
      obiekt: null,
      rodzajZdarzenia: null,
      autorNazwa: '',
    };
    this.resetFilters();
  }

  protected getRodzajZdarzeniaLabel(value: string): string {
    return this.ANNOUNCEMENT_EVENT_TYPE[
      value as keyof typeof AnnouncementEventType
    ] ?? value;
  }
}
